import AuthorizationStore from '../../common_components/authorization/AuthorizationStore';
// import {
//     SHOW_BUSINESS_ALLOWED_ROLES,
//     EDIT_BUSINESS_ALLOWED_ROLES
// } from "../../common_components/authorization/allowed_roles";
// import {STARTUP_ROLES} from "../../common_components/authorization/constants";
// import {AuthorizeComponent} from "../../common_components/authorization/Authorization";

export default class Authorization extends AuthorizationStore {
  constructor(rootStore, currentUserPermission) {
    super(rootStore, currentUserPermission);
  }


  get authShow() {
    return this.authorizeComponent(this.canShowBusinessActivity);
    // return this.authorization(SHOW_BUSINESS_ALLOWED_ROLES)
  }


  get authEdit() {
    return this.authorizeComponent(this.canManageBusinessActivity);
    // return this.authorization(EDIT_BUSINESS_ALLOWED_ROLES)
  }


  get canEdit() {
    return this.canManageBusinessActivity
            && (
              (this.rootStore.igBusinessStore)
                || (
                  !this.rootStore.isBmcVision
                    && this.rootStore.belongsToCurrentMvp
                )
                || (
                  this.rootStore.isBmcVision
                    && this.rootStore.thinkingMode.active
                    && this.rootStore.thinkingMode.atBmcVision
                )
            );
  }

  get canEditStage() {
    return this.canManageBusinessActivity;
  }

  canDeleteCard(card) {
    return card
            && card.creator
            && this.rootStore.user.id === card.creator.id
            || this.canManageBusinessActivity;
  }


  get canShowOptions() {
    return !this.rootStore.isBmcVision;
  }

  get canRedirectToStepByStep() {
    return this.canEdit
            && this.rootStore.emptyBlocks
            && !this.rootStore.closeStepByStepMode;
  }
}
